export default __webpack_public_path__ + "static/media/icon-reschedule-dark.88c191b6.svg";